<template>
  <div>
    <nav class="navbar container navbar-expand-lg navbar-light" style="background-color:#e9ecef !important">
      <a class="navbar-brand d-none d-md-block" href="#">
        <img class="" style="width:20%;" src="static/img/logoPsicologia.png" alt="">
        Facultad de Psicología UANL
      </a>
      <a class="navbar-brand d-block d-md-none" href="#">
        <img class="" style="width:25%;" src="static/img/logoPsicologia.png" alt="">
        FAPSI UANL
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item mr-md-4" :class="{'active':opcion_activa=='Registro'}">
            <a class="nav-link" href="" v-on:click.prevent="Registro">Registro</a>
          </li>
          <li class="nav-item mr-md-4" :class="{'active':opcion_activa=='Presentar'}">
            <a class="nav-link" href="" v-on:click.prevent="Presentar">Exámen</a>
          </li>
        </ul>
      </div>
    </nav>
    <div class="container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      opcion_activa:'Registro'
    }
  },
  methods:{
    Presentar(){
      this.opcion_activa='Presentar';
      this.$router.push({name:'Presentar'});
    },
    Registro(){
      this.opcion_activa='Registro';
      this.$router.push({name:'Registro'});
    }
  },
  created(){
    if (this.$route.name=='MenuPrincipal') {
      this.Registro();
    }else{
      this.$router.push({name:this.$route.name});
    }
  }
};
</script>

<style scoped>
li.active{
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/MenuPrincipal.vue